<template>
  <div>
    <b-navbar toggleable="lg" type="dark" variant="dark" class="py-0">
      <!-- <b-button v-bind:class='{inactive:!backable}' @click="$router.push({path:'/'})"><i class="fas fa-backspace"></i></b-button> -->
      <!-- <b-navbar-brand href="#">ZekkenJockey</b-navbar-brand> -->
      <a href="/"><img v-bind:src="require('../assets/logo_zekkenjockey_white.png')"></a>
      <b-button v-b-modal.modal-qr variant="info"><i class="fas fa-qrcode"></i> QR</b-button>
    </b-navbar>

    <b-card class="text-center">
      <template v-slot:header>
        {{ event_title }}<br/>
        <small class="text-muted">
          {{ startTimeText }}スタート
        </small>
      </template>
      <b-card-text class="text-monospace">
       <h4>{{ clockText }}</h4>
      </b-card-text>
    </b-card>

    <div v-bind:class='{inactive:isError}'>
      <b-tabs small align="center">
        <b-tab title="総合" @click="changeGenre()" ></b-tab>
        <span v-for="genre in genreList" v-bind:key='genre'>
          <b-tab :title="genre" :active="genre == genreFilter" @click="changeGenre(genre)"></b-tab>
        </span>
      </b-tabs>
      <b-input-group prepend="No." class="my-3 ml-2">
        <b-form-input id="filter" v-model="zekkenFilter" v-bind:class='{inactive:isError}'></b-form-input>
        <b-input-group-append class="mr-3">
          <b-button variant="outline-success"  @click="createCheckinRecordLoader(zekkenFilter)">絞り込み</b-button>
        </b-input-group-append>
      </b-input-group>
      <b-table responsive striped hover small :items="ranking" :fields="fields">
        <template v-slot:head()="scope">
          <div class="text-nowrap">
            {{ scope.label }}
          </div>
        </template>
        <template v-slot:cell()="row">
          <div class="text-nowrap"  v-b-modal.modal-runner @click="makePersonalRecord(row.item.zekken)">
            {{ row.value }}
          </div>
        </template>
      </b-table>
      <div class="text-right">
        <b-button class="mb-4 mr-2" size="sm" variant="outline-info" @click="downloadCSV">
          CSV Download
        </b-button>
      </div>
      <p class="small text-center">
        ※名前をタップでラップタイムを表示できます。
      </p>
    </div>

    <div>
      <!-- QRコード表示ダイアログ -->
      <b-modal id="modal-qr" title="ZekkenJockey QR" ok-only centered>
        <div  class="text-center"><vue-qrcode v-if="thisPageURL" :value="thisPageURL" :options="qrOption" tag="img"></vue-qrcode></div>
        <p class="small text-center">このQRコードをスキャンするとタイム一覧を共有できます。</p>
      </b-modal>

      <!-- 個人レコード表示ダイアログ -->
      <b-modal id="modal-runner" title="個人レコード" ok-only centered>
        <div  class="text-center"></div>
        <b-card>
          <b-row>
            <b-col><b>No:</b></b-col>
            <b-col cols="6" class="text-left">{{ personalRecord['zekken'] }}</b-col>
          </b-row>
          <b-row>
            <b-col><b>名前:</b></b-col>
            <b-col cols="6" class="text-left text-nowrap">{{ personalRecord['name'] }}</b-col>
          </b-row>
          <b-row>
            <b-col><b>種目:</b></b-col>
            <b-col cols="6" class="text-left text-nowrap">{{ personalRecord['genre'] }}</b-col>
          </b-row>
          <b-row>
            <b-col><b>トータルタイム:</b></b-col>
            <b-col cols="6" class="text-left text-nowrap">{{ personalRecord['splitTimeString'] }}</b-col>
          </b-row>
          <b-row>
            <b-col><b>ラップ平均:</b></b-col>
            <b-col cols="6" class="text-left text-nowrap">{{ personalRecord['averageTimeString'] }}</b-col>
          </b-row>
          <b-row>
            <b-col><b>周回数:</b></b-col>
            <b-col cols="6" class="text-left text-nowrap">{{ personalRecord['lapSeconds'].length }}</b-col>
          </b-row>

          <b-list-group flush class="mt-4">
            <!-- <b-list-group-item class="pt-2 pb-1" small v-for="(sec, index) in personalRecord['seconds']" v-bind:key="index"> -->
            <b-list-group-item class="pt-2 pb-1" small v-for="(sec, index) in personalRecord['lapSeconds']" v-bind:key="index">
              {{index+1}}. {{ seconds_to_record(sec) }}
            </b-list-group-item>
          </b-list-group>
        </b-card>

        <template v-slot:modal-footer="{ ok, hide }">
          <b-button size="sm" variant="outline-info" @click="downloadPersonalRecord( personalRecord )">
            CSV Download
          </b-button>
          <b-button size="sm" variant="success" @click="ok()">
            OK
          </b-button>
        </template>

      </b-modal>
    </div>

  </div>
</template>

<script>
import firebase from 'firebase/app'
import 'firebase/firestore'
import moment from 'moment'
import Mixin from '../utility'
import VueQrcode from '@chenfengyuan/vue-qrcode'

export default {
  name: 'App',
  components: {
    VueQrcode
  },
  data () {
    return {
      q: null,
      type: null,
      code: null,
      thisPageURL: document.URL,
      event_title: null,
      delayseconds: 0, // スタートタイムが遅れた場合に設定
      delay_by_genre: false, // 種目別にスタートタイムが分かれる場合にTrueを指定する。ジャンル指定ドキュメントを読みに行く。
      genreDelays: [], // 時差スタートの設定を読み込む
      minimumlapsec: 0, // この秒数以下の間隔のチェックインは重複とみなして無視する
      checkstyle: 'lap', // lap: 周回形式, gate:関門形式, goal:ゴールのみ
      startTimeText: '',
      limitMoment: null,
      clockText: '',
      collection: null,
      unsubscribe: null,
      isError: false,
      rankTable: {},
      checkinsCount: 0,
      ranking: [],
      genreTable: {},
      genreList: [],
      genreFilter: '',
      zekkenFilter: '',
      backDisable: false,
      personalRecord: {
        zekken: null,
        name: null,
        genre: null,
        splitTimeString: null,
        averageTimeString: null,
        seconds: [],
        lapSeconds: []
      },
      fields: [
        {
          key: 'rank',
          label: '順位',
          sortable: true,
          stickyColumn: false
        },
        {
          key: 'zekkenString',
          label: 'No.',
          sortable: true,
          stickyColumn: false
        },
        {
          key: 'name',
          label: '名前',
          sortable: false,
          stickyColumn: true
        },
        {
          key: 'lapCount',
          label: '周回',
          sortable: true
        },
        {
          key: 'splitTimeString',
          label: 'タイム',
          sortable: true
        },
        {
          key: 'genre',
          label: '種目',
          sortable: false
        }
      ],
      checkinsFields: [
        {
          key: 0,
          label: 'rap',
          sortable: false
        },
        {
          key: 1,
          label: 'check-in time',
          sortable: false
        }
      ],
      qrOption: {
        errorCorrectionLevel: 'M',
        maskPattern: 0,
        margin: 4,
        scale: 2,
        width: 300,
        color: {
          dark: '#000000FF',
          light: '#FFFFFFFF'
        }
      }
    }
  },
  mixins: [Mixin],
  created () {
    console.log('creating...')
    this.code = this.$route.query.code
    this.backable = this.$route.query.back === 'true' // true以外は非表示
    this.genreFilter = this.$route.query.genre === undefined ? '' : this.$route.query.genre
    console.log('default query : ' + this.code)
    this.loadEventDb(this.code)
    console.log('created!')
  },
  mounted () {
    console.log('mounting...')
    this.init_in_mounted()
    console.log('mounted!')
  },
  computed: {
  },
  methods: {
    init_in_mounted: async function () {
      await this.fetchEventInformation()
      await this.createCheckinRecordLoader()
      setInterval(this.createCurrentClock, 61)
    },
    deleteQuery: function (key) {
      var query = Object.assign({}, this.$route.query)
      if (query[key] !== 'undefined') {
        delete query[key]
        this.$router.push({query: query})
      }
    },
    // buildInformer: function (code) {
    //   this.loadEventDb(code)
    //   this.fetchEventInformation()
    //   this.createCheckinRecordLoader()
    // },
    loadEventDb: function (eventcode) {
      console.log(eventcode)
      if (eventcode === null) {
        return
      }
      var db = firebase.firestore()
      this.collection = db.collection(eventcode.toUpperCase())
    },
    fetchEventInformation: function () {
      if (this.collection == null) {
        this.eventNotFound()
        return
      }
      // this.removeRegulations()
      // イベント情報の取得と表示
      var event = this.collection.doc('event')
      event.get().then(function (doc) {
        if (doc.exists) {
          const info = doc.data()
          console.log(info)
          const startMoment = moment(info.start.toDate())
          const limitMoment = moment(info.limit.toDate())
          this.limitMoment = moment(info.limit.toDate())

          this.event_title = info.name
          this.delayseconds = info.delayseconds
          this.minimumlapsec = info.minimumlapsec

          this.startTimeText = startMoment.format('YYYY年MM月DD日 HH時mm分')
          this.limitTimeText = limitMoment.format('YYYY-MM-DD HH:mm:ss')

          this.checkstyle = info.checkstyle ? info.checkstyle : this.checkstyle
          if (this.checkstyle !== 'lap') {
            this.fields = this.fields.filter(f => {
              return f.key !== 'lapCount'
            })
          }

          // イベント情報の取得と表示

          // ジャンルディレイのロード
          console.log(info.genreDelays)
          if (info.genreDelays) {
            this.genreDelays = info.genreDelays
            console.log('genre delays loaded!: ' + this.genreDelays)
          }

          console.log('Evenet name : ', info.name)
          console.log('Start time : ', startMoment.format('YYYY-MM-DD hh:mm:ss'))
          console.log('Limit time : ', limitMoment.format('YYYY-MM-DD hh:mm:ss'))
          console.log('delay time(sec) : ', info.delayseconds)
          console.log('minimum lap time(sec) : ', info.minimumlapsec)
          console.log('checkstyle : ', this.checkstyle)
        } else {
          // doc.data() will be undefined in this case
          console.log('No such document!')
          this.eventNotFound()
        }
      }.bind(this)
      ).catch(function (error) {
        console.log('Error getting document:', error)
      })
    },
    eventNotFound () {
      this.event_title = 'イベントが見つかりませんでした。'
      this.isError = true
    },
    removeRegulations () {
      const ul = document.getElementById('regulations')
      while (ul.hasChildNodes()) {
        ul.removeChild(ul.firstChild)
      }
    },
    removeCheckins () {
      // this.clearCheckins()
      if (this.unsubscribe != null) {
        this.unsubscribe()
      }
    },
    clearCheckins () {
      const ul = document.getElementById('messages')
      while (ul.hasChildNodes()) {
        ul.removeChild(ul.firstChild)
      }
    },
    createCheckinRecordLoader (filter) {
      if (this.collection == null) {
        return
      }
      if (filter === undefined) {
        filter = ''
      }

      var checkins = this.collection.doc('records').collection('check-ins')

      // チェックインの取得
      let self = this
      this.rankTable = {} // 作り直す
      self.checkinsCount = 0
      this.removeCheckins()
      this.unsubscribe = checkins.orderBy('seconds', 'desc').onSnapshot(snapshot => {
        snapshot.docChanges().forEach(change => {
          if (change.type === 'added') {
            const d = change.doc.data()
            self.addRankTable(d, filter)
            self.checkinsCount += 1
          }
        })
        self.buildLapTime() // self.rankTable[].lapSeconds を構築
        self.showRankTable() // self.ranking[] を構築
        // self.storeRankTableCache()  // firestorageにランクテーブルを格納
        self.genreList = Object.keys(self.genreTable)
      })
    },
    addRankTable: function (data, filter) {
      this.genreTable[data.genre] = true
      if (this.isFiltOut(data, filter)) {
        return
      }

      //   li.textContent = this.zp(4, d.zekken) + ' : ' + d.name + ' : ' + this.seconds_to_record(d.seconds)
      if (!this.rankTable[data.zekken]) {
        // キーが存在しないとき
        let value = {
          zekken: data.zekken,
          name: data.name,
          seconds: [data.seconds],
          genre: data.genre
          // lapCount: 1
        }
        this.rankTable[data.zekken] = value
      } else {
        // lapCountはdata.seconds.lengthで代用
        this.rankTable[data.zekken]['seconds'].push(data.seconds)
      }
    },
    // 実測（ダブリ計測有り）のリストから、スタートディレイ・ダブリ計測を除去したラップタイムを構築する
    buildLapTime: function () {
      const self = this
      Object.keys(this.rankTable).forEach(zekken => {
        self.rankTable[zekken].lapSeconds = self.makeLapSeconds(self.rankTable[zekken].seconds, self.rankTable[zekken].genre)
      })
    },
    isFiltOut: function (data, filter) {
      if (filter !== '' && data.zekken !== parseInt(filter)) {
        return true
      }
      if (this.genreFilter !== '' && this.genreFilter !== data.genre) {
        return true
      }
      return false
    },
    showRankTable: function () {
      // this.clearCheckins()
      this.ranking = []
      // ランク表示用の配列を構築
      for (let key in this.rankTable) {
        let d = this.rankTable[key]

        // チェックインの配列をラップタイムの配列に変換する
        const lapSeconds = this.makeLapSeconds(d.seconds, d.genre)
        // lapSecondsの合計をsplitTimeとする
        // let splitTime = lapSeconds.reduce(function (sum, i) { return (sum + i) }, 0)
        // splitTimeにジャンルディレイを考慮する
        let splitTime = lapSeconds.reduce(function (sum, i) { return (sum + i) }, 0)

        const lapCount = lapSeconds.length
        if (lapCount === 0) { // ラップ数がゼロは、スタート前のテストチェックインなので一覧に表示しない
          continue
        }

        const averageTime = Math.round(splitTime / lapCount)

        let result = {
          zekken: d.zekken,
          zekkenString: this.zp(4, d.zekken),
          name: d.name,
          genre: d.genre,
          lapCount: lapCount,
          splitTime: splitTime,
          splitTimeString: this.seconds_to_record(splitTime),
          averageTimeString: this.seconds_to_record(averageTime),
          lapSeconds: d.lapSeconds
        }
        this.ranking.push(result)
      }

      // ラップ数の多い順、スプリットタイムの小さい順にソート
      this.ranking.sort((a, b) => {
        if (a.lapCount > b.lapCount) { return -1 }
        if (a.lapCount < b.lapCount) { return 1 }
        if (a.splitTime < b.splitTime) { return -1 }
        if (a.splitTime > b.splitTime) { return 1 }
        return 0
      })

      // 順位を追加
      this.ranking.forEach((runner, rank) => {
        runner['rank'] = rank + 1
      })
    },
    getRankingRecordByZekken: function (zekken) {
      for (let key in this.ranking) {
        const info = this.ranking[key]
        if (info.zekken === zekken) {
          return info
        }
      }
      return null
    },
    storeRankTableCache: function () {
      const db = firebase.firestore()
      const records = db.collection(this.code.toUpperCase()).doc('records')
      records.get().then(doc => {
        if (!doc.exists) {
          console.log('no countup data.')
        } else {
          const counts = doc.data()['check-ins-count']
          console.log('counts : ' + counts) // このカウントを実際の値と比較する
          console.log('check ins counts : ' + this.checkinsCount) // 実測値
          if (this.checkinsCount > counts) {
            const samples = db.collection(this.code.toUpperCase()).doc('samples')
            samples.update({
              'check-ins-count': this.checkinsCount
            })
          }
        }
      })
    },
    forwardQrcodePage: function (str) {
      this.$router.push({
        path: '/qr',
        query: {
          targetUrl: document.URL
        }
      })
    },
    changeGenre: function (genre) {
      this.zekkenFilter = ''
      if (genre === undefined) {
        genre = ''
      }
      if (genre === this.genreFilter) {
        return
      }
      this.$router.push({path: '/seats',
        query: {
          code: this.code,
          genre: genre,
          back: this.backable
        }})
      this.genreFilter = genre
      this.createCheckinRecordLoader(this.filter)
    },
    createCurrentClock: function () {
      const now = moment()
      if (now.isAfter(this.limitMoment)) {
        this.clockText = 'finished'
      } else {
        this.clockText = now.format('H時m分s秒SSS')
      }
    },
    makePersonalRecord: function (zekken) {
      // const zekken = this.ranking[runnerRank].zekken
      const rankingInfo = this.getRankingRecordByZekken(zekken)
      this.personalRecord = this.rankTable[zekken]
      this.personalRecord.seconds.sort((a, b) => a - b)
      this.personalRecord.lapSeconds = rankingInfo.lapSeconds
      this.personalRecord.splitTimeString = rankingInfo.splitTimeString
      this.personalRecord.averageTimeString = rankingInfo.averageTimeString
    },
    // 最小ラップをや時差スタートを考慮したラップタイムを構築する
    makeLapSeconds: function (seconds, genre) {
      const genreDelay = this.genreDelays[genre] ? this.genreDelays[genre] : 0
      // if (genreDelay !== 0) {
      //   console.log('genre delay: ' + genreDelay)
      // } else {
      //   console.log('no genre delay!: ' + genre + ' / ' + this.genreDelays)
      // }
      let totalDelay = this.delayseconds + genreDelay
      let lastLap = totalDelay
      return seconds.slice().sort((a, b) => a - b).map(sec => {
        if (sec < 0) { sec = 0 }

        const diffLap = sec - lastLap
        if (diffLap > this.minimumlapsec) {
          lastLap = sec
        }
        return diffLap
      }).filter(sec => {
        return sec > this.minimumlapsec
      })
    },
    downloadCSV () {
      var csv = this.ranking.map(record => {
        const zekken = record.zekkenString
        const name = record.name
        const genre = record.genre
        const splitTimeString = record.splitTimeString
        const averageTimeString = record.averageTimeString
        const lapCount = record.lapCount

        return `${zekken},${name},${genre},${lapCount},${splitTimeString},${averageTimeString}\n`
      })

      csv.unshift('\ufeff' + 'ゼッケン,名前,種目,ラップ数,トータルタイム,ラップ平均タイム\n')
      this.__exec_download(csv)
    },
    downloadPersonalRecord (record) {
      console.log(record)
      var csv = []
      csv.unshift('\ufeff' + '個人レコード')
      csv.push(`No,${record.zekken}`)
      csv.push(`名前,${record.name}`)
      csv.push(`種目,${record.genre}`)
      csv.push(`トータルタイム,${record.splitTimeString}`)
      csv.push(`ラップ平均,${record.averageTimeString}`)
      csv.push(`周回数,${record.lapSeconds.length}`)
      record.lapSeconds.map((sec, index) => {
        csv.push(`${index + 1},${this.seconds_to_record(sec)}`)
      })
      this.__exec_download(csv, '\n')
    },
    __exec_download (csv, delimiter = '') {
      let blob = new Blob([csv.join(delimiter)], { type: 'text/plain' })
      let link = document.createElement('a')
      link.href = window.URL.createObjectURL(blob)
      link.download = 'Result.csv'
      link.click()
    }

  }
}
</script>

<style>
.inactive{
  display:none;
}
</style>



// WEBPACK FOOTER //
// src/components/seats.vue